import { exec, spawn } from "child_process";

/**
 * Executes a shell command (non-interactive).
 * @param {string} cmd - The shell command to execute.
 * @returns {Promise<string>} - Resolves with stdout, rejects with error/stderr.
 */
export const execute = (cmd: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    exec(cmd, (error: Error | null, stdout: string, stderr: string) => {
      if (error) {
        reject(stderr || error.message);
      } else {
        resolve(stdout);
      }
    });
  });
};

/**
 * Spawns an interactive shell command.
 * Streams stdio to the parent process.
 * @param {string} cmd - The command to run.
 * @param {string[]} args - Arguments for the command.
 * @param {object} [options] - Optional spawn options.
 * @returns {Promise<number>} - Resolves with exit code.
 */
export const executeInteractive = (cmd: string, args: string[] = [], options: object = {}): Promise<number> => {
  return new Promise((resolve, reject) => {
    const child = spawn(cmd, args, {
      stdio: "inherit",
      shell: true,
      ...options,
    });

    child.on("close", (code) => {
      resolve(code ?? 0);
    });

    child.on("error", (err) => {
      reject(err);
    });
  });
};
